// Registers the minimal app-shell service worker (public/service-worker.js)
// in production builds only, so local development is never served stale code.
export function registerServiceWorker() {
  if (process.env.NODE_ENV !== "production" || !("serviceWorker" in navigator)) return;
  window.addEventListener("load", () => {
    navigator.serviceWorker.register(`${process.env.PUBLIC_URL}/service-worker.js`).catch(() => {
      // Non-fatal: the app works normally without offline shell caching.
    });
  });
}
